import { render, staticRenderFns } from "./AdInsightsDrawer.vue?vue&type=template&id=0a647276&scoped=true"
import script from "./AdInsightsDrawer.vue?vue&type=script&lang=js"
export * from "./AdInsightsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a647276",
  null
  
)

export default component.exports